export const useGetDataAttributes = (p: AnyObject) => {
  const dataAttributes = {} as AnyObject;
  Object.keys(p).forEach(k => {
    if (k.match(/^data-/)) dataAttributes[k] = p[k];
  })
  return dataAttributes;
}